<template>
  <div class="fridge">
    <div class="content c895">
      <h2>Dodajte hladilnik</h2>
    </div>
    <div class="content c590">
      <div class="form">
        <h3>VPIŠITE PODATKE O HLADILNIKU</h3>
        <fieldset>
          <div class="f-item radio">
            <label>Tip hladilnika:</label>
            <table id border="0">
              <tbody>
                <tr>
                  <td>
                    <input
                      id="Hlad"
                      type="radio"
                      name="hladilnik"
                      value="1"
                      v-model="checked"
                      @click="checker = !checker"
                      :checked="checker"
                    />
                    <label for="Hlad">Hladilnik</label>
                  </td>
                  <td>
                    <input
                      id="Komb"
                      type="radio"
                      name="kombiniran"
                      value="2"
                      v-model="checked"
                      @click="checker = !checker"
                      :checked="!checker"
                    />
                    <label for="Komb">
                      Kombinirani hladilnik
                      <span>(hladilnik in zmrzovalnik)</span>
                    </label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="f-item select">
            <label>
              Prostornina:
              <span id style="color:Red;float:none;font-size:1em;visibility:hidden;">*</span>
              <span>(oz. višina)</span>
            </label>
            <select v-model="size" :style="{display: checked == 2 ? 'block' : 'none'}">
              <option value="0">Izberite</option>
              <option value="18">85 cm - 103 l hladilnika - 17 l zamrzovalnika</option>
              <option value="17">85 cm - 124 l hladilnika - 21 l zamrzovalnika</option>
              <option value="16">104 cm - 145 l hladilnika - 17 l zamrzovalnika</option>
              <option value="15">113 cm - 134 l hladilnika - 36 l zamrzovalnika</option>
              <option value="14">123 cm - 145 l hladilnika - 48 l zamrzovalnika</option>
              <option value="13">125 cm - 183 l hladilnika - 17 l zamrzovalnika</option>
              <option value="12">144 cm - 247 l hladilnika - 21 l zamrzovalnika</option>
              <option value="11">144 cm - 190 l hladilnika - 68 l zamrzovalnika</option>
              <option value="10">156 cm - 205 l hladilnika - 59 l zamrzovalnika</option>
              <option value="9">180 cm - 200 l hladilnika - 86 l zamrzovalnika</option>
              <option value="8">180 cm - 230 l hladilnika - 86 l zamrzovalnika</option>
              <option value="7">180 cm - 230 l hladilnika - 75 l zamrzovalnika</option>
              <option value="6">180 cm - 205 l hladilnika - 103 l zamrzovalnika</option>
              <option value="5">180 cm - 223 l hladilnika - 61 l zamrzovalnika</option>
              <option value="4">186 cm - 211 l hladilnika - 118 l zamrzovalnika</option>
              <option value="3">200 cm - 245 l hladilnika - 86 l zamrzovalnika</option>
              <option value="2">200 cm - 278 l hladilnika - 86 l zamrzovalnika</option>
              <option value="1">200 cm - 245 l hladilnika - 75 l zamrzovalnika</option>
              <option value="169">154 cm - 229 l hladilnika - 25 l zamrzovalnika</option>
              <option value="166">176 cm - 345 l hladilnika - 192 l zamrzovalnika</option>
              <option value="163">177 cm - 370 l hladilnika - 179 l zamrzovalnika</option>
              <option value="165">177 cm - 373l hladilnika - 204 l zamrzovalnika</option>
              <option value="168">185 cm - 222 l hladilnika - 85 l zamrzovalnika</option>
              <option value="170">200 cm - 254 l hladilnika - 80 l zamrzovalnika</option>
            </select>
            <select v-model="size" :style="{display: checked == 1 ? 'block' : 'none'}">
              <option value="0">Izberite</option>
              <option value="5">85 cm - 156 l hladilnika</option>
              <option value="4">125 cm - 217 l hladilnika</option>
              <option value="3">144 cm - 284 l hladilnika</option>
              <option value="2">180 cm - 346 l hladilnika</option>
              <option value="1">180 cm - 388 l hladilnika</option>
            </select>
            <!-- tooltip + div added-->
            <div class="help">
              <a href="#" class="help" title="Help">Help</a>
              <div class="tooltip">Izberite ustrezno kombinacijo višine in prostornine hladilnika.</div>
            </div>
            <!-- //end -->
          </div>
          <div class="f-item select">
            <label>
              Energijski razred:
              <span
                id
                style="color:Red;float:none;font-size:1em;visibility:hidden;"
              >*</span>
              <span>(oz. leto izdelave naprave)</span>
            </label>
            <select v-model="razred">
              <option value="0">Izberite</option>
              <option value="1">A+++ (po 2002)</option>
              <option value="2">A++ (po 2002)</option>
              <option value="3">A+ (po 2002)</option>
              <option value="4">A (po 2002)</option>
              <option value="5">B (1996-2002)</option>
              <option value="6">C (1992-1995)</option>
              <option value="7">D (pred 1992)</option>
              <option value="8">E (pred 1992)</option>
            </select>
            <div class="help">
              <a href="#" class="help" title="Help">Help</a>
              <div class="tooltip">
                Če ne poznate energijskega razreda hladilnika, lahko glede na leto nakupa določite približen energijski razred. Pred določenim letom namreč aparatov nekaterih energijskih razredov še niso proizvajali.
                <p></p>
              </div>
            </div>
          </div>
          <div class="commands">
            <input type="submit" name value="Dodaj" @click="addedApplianceNum()" />
          </div>
        </fieldset>
      </div>
    </div>
    <div class="content r-c">
      <div class="c282 info">
        <h3>INFO O HLADILNIKU</h3>
        <p>Hladilnik je med večjimi porabniki električne energije v gospodinjstvu, a z nekaj preprostimi ukrepi lahko račun za elektriko vseeno učinkovito znižate.“Varčen” hladilnik ali zamrzovalnik porabi polovico ali celo manj energije od starega, tehnološko zastarelega in izrabljenega.</p>

        <div class="average">
          <h4>Povprečna poraba hladilnika</h4>
          <span>300 kWh/ leto</span>
          <p>
            <strong>22,64 € / leto</strong> (enotarifno)
            <br />
            <strong>19,42 € / leto</strong> (dvotarifno)
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HladilnikObj from '../classes/hladilnik';

export default {
  data: function () {
    return {
      checker: true,
      checked: '1',
      razred: 0,
      size: 0,
    };
  },
  methods: {
    addedApplianceNum() {
      console.log('entered Hladilnik');
      console.log(this.checked);
      const H = new HladilnikObj(this.checked, this.size, this.razred);
      console.log('From Hladilnik');
      this.$emit('applianceFormClicked', H);
    },
  },
};
</script>

<style>
</style>